import React, { createContext, useContext as useContextCore } from 'react'
import type { Colors } from '@ztechapps/common.hook'
import { ThemeProvider, ToastProvider } from '@ztechapps/webui.util'
import { ConfirmDialogProvider } from '@ztechapps/webui.modal'
import { AddressEditPopOverProvider } from '@ztechapps/webui.location'
import { DependencyProvider } from '@ztechapps/webui.contract'
import { TelemetryProvider, useWebVitals, usePageView, OpenReplayProvider } from '@ztechapps/webui.telemetry'
import { setupContainer } from '../../config/setup-container'
import { telemetryConfig, openReplayConfig } from '../../config/app-settings'

export type AppContextType = {
  data?: any
}

const context = createContext<AppContextType>(null)
const CoreProvider = context.Provider

const themeColors: Colors = {
  primary: '#5262e5',
  primary75: '#7d89eb',
  primary50: '#a8b0f2',
  primary25: '#d3d7f8',
}

//we need to load all the modules here
const container = setupContainer()

/**
 * Inner component that uses telemetry hooks
 * Must be inside TelemetryProvider
 */
function TelemetryInitializer({ children }: { children: React.ReactNode }) {
  // Collect Core Web Vitals
  useWebVitals()
  // Track page views on route changes
  usePageView()

  return children
}

export const AppContextProvider = ({ children }) => {
  return (
    <TelemetryProvider config={telemetryConfig}>
      <DependencyProvider container={container}>
        <CoreProvider value={{}}>
          <ToastProvider>
            <ThemeProvider routerType="react-router" colors={themeColors}>
              <OpenReplayProvider config={openReplayConfig}>
                <TelemetryInitializer>
                  <ConfirmDialogProvider>
                    <AddressEditPopOverProvider>{children}</AddressEditPopOverProvider>
                  </ConfirmDialogProvider>
                </TelemetryInitializer>
              </OpenReplayProvider>
            </ThemeProvider>
          </ToastProvider>
        </CoreProvider>
      </DependencyProvider>
    </TelemetryProvider>
  )
}

export const useAppContext = () => useContextCore(context)
